import { gql } from "@apollo/client"

export const ENGAGEMENTS = gql`
  query Engagements(
    $staff_id: ID
    $idTemplate: ID!
    $participant_membership_id: ID
  ) {
    engagements: blocksSavedByIdTemplate(
      staff_id: $staff_id
      idTemplate: $idTemplate
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const ENGAGEMENTS_PARTICIPANT = gql`
  query EngagementsParticipant(
    $participant_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $participant_membership_id: ID
  ) {
    engagementsParticipant: blocksSavedByParticipantIdTemplate(
      participant_id: $participant_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const TEMPLATE_STATS = gql`
  query templateStats($participant_membership_id: ID, $staff_id: String) {
    stats: getSpecificBlocksStatsByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["session", "session__recovery_plan", "session__group_session"]
    ) {
      data
    }
    engagements: getSpecificBlocksByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["session", "session__recovery_plan", "session__group_session"]
    ) {
      data
    }
    templateNames: templates(type: "system", staff_id: $staff_id) {
      template_name
      template_title
    }
  }
`
export const ENGAGEMENTS_PARTICIPANT_GROUP_BY_TEMPLATE = gql`
  query EngagementsParticipant(
    $participant_id: ID!
    $organization_id: ID!
    $idTemplates: [ID]
    $idBlocks: [ID]
    $participant_membership_id: ID
  ) {
    engagementsParticipant: getAllParticipantBlocksGroupByIdTemplate(
      participant_id: $participant_id
      organization_id: $organization_id
      idTemplates: $idTemplates
      idBlocks: $idBlocks
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const ENGAGEMENTS_COUNT = gql`
  query GetEngagements(
    $participant_membership_id: ID!
    $participant_id: ID!
    $organization_id: ID!
  ) {
    engagementsKpi(
      participant_membership_id: $participant_membership_id
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      data
    }
  }
`

export const ENGAGEMENTS_CHART = gql`
  query GetEngagementsDate(
    $participant_membership_id: ID!
    $query_type: String!
    $numberOfDays: Int
    $year: String
  ) {
    engagementsKpiPerDate(
      participant_membership_id: $participant_membership_id
      query_type: $query_type
      numberOfDays: $numberOfDays
      year: $year
    ) {
      data
    }
  }
`
export const GET_LABEL = gql`
  query GetLabelChart($parent: String!, $enterprise_id: ID!) {
    label(parent: $parent, enterprise_id: $enterprise_id) {
      data
    }
  }
`

export const GET_MAX_SERVICE_EPISODE = gql`
  query getMaxServiceEpisode(
    $staff_id: ID!
    $organization_id: ID!
    $participant_id: ID!
    $participant_membership_id: ID!
  ) {
    getMaxServiceEpisode(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_id: $participant_id
      participant_membership_id: $participant_membership_id
    ) {
      service_episodes_id
      episode_intake_date
      manage_services_date
      episode_code_id
      program_ids
      staff_ids
      location_ids
      episode_intake_uid
      manage_services_uid
      episode_discharge_uid
      episode_discharge_date
      external_ids
      template_name
    }
  }
`

export const GET_PAST_SERVICE_EPISODE = gql`
  query getPastServiceEpisodes(
    $staff_id: ID!
    $organization_id: ID!
    $participant_id: ID!
    $participant_membership_id: ID!
  ) {
    getPastServiceEpisodes(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_id: $participant_id
      participant_membership_id: $participant_membership_id
    ) {
      service_episodes_id
      episode_intake_date
      episode_discharge_date
      episode_intake_uid
      manage_services_uid
      episode_discharge_uid
    }
  }
`

export const GET_PAST_SERVICE_EPISODE_SUMMARIZED = gql`
  query getPastServiceEpisodesSummarized(
    $staff_id: ID!
    $organization_id: ID!
    $participant_id: ID!
    $participant_membership_id: ID!
  ) {
    getPastServiceEpisodesSummarized(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_id: $participant_id
      participant_membership_id: $participant_membership_id
    ) {
      episode_number
      episode_intake_date
      episode_discharge_date
      manage_services_date
      __typename
    }
  }
`

export const GET_SERVICE_EPISODE = gql`
  query getServiceEpisode(
    $staff_id: ID!
    $organization_id: ID!
    $service_episodes_id: ID!
  ) {
    getServiceEpisode(
      staff_id: $staff_id
      organization_id: $organization_id
      service_episodes_id: $service_episodes_id
    ) {
      service_episodes_id
      episode_intake_date
      manage_services_date
      episode_code_id
      program_ids
      staff_ids
      location_ids
    }
  }
`

export const GET_SERVICE_EPISODE_BY_EPISODE_NUMBER = gql`
  query getServiceEpisodebyEpisodeNumber(
    $staff_id: ID!
    $organization_id: ID!
    $participant_id: ID!
    $participant_membership_id: ID!
    $episode_number: ID!
  ) {
    getServiceEpisodebyEpisodeNumber(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_id: $participant_id
      participant_membership_id: $participant_membership_id
      episode_number: $episode_number
    ) {
      service_episodes_id
      episode_intake_date
      manage_services_date
      episode_code_id
      program_ids
      staff_ids
      location_ids
      episode_intake_uid
      manage_services_uid
      episode_discharge_uid
      participant_id
      episode_discharge_date
      external_ids
      template_name
      __typename
    }
  }
`
